// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__r-0EU","vLegacy":"SelectSecondary_vLegacy__3pVkJ","error":"SelectSecondary_error__3h33G","disabled":"SelectSecondary_disabled__H8NXo"};